<template>
    <x-modal :id="id" :title="modalTitle">
        <x-table
            :headers="[
                '#',
                'Kode',
                'Email',
                'Nama',
                'Usia',
                'No Telpon',
                'Alamat',
                'Jenis Kelamin',
                'Check-In',
                'Pos Check-In',
                '',
            ]"
        >
            <tr v-for="(resource, index) in subscribers" :key="index">
                <td class="nowrap">{{ index + 1 }}</td>
                <td class="nowrap">{{ resource.code }}</td>
                <td class="nowrap">{{ resource.email }}</td>
                <td class="nowrap">{{ resource.name }}</td>
                <td class="nowrap">{{ resource.dob | age }}</td>
                <td class="nowrap">{{ resource.phone }}</td>
                <td class="nowrap">
                    <div v-html="$options.filters.nl2br(resource.address)" />
                </td>
                <td class="nowrap">{{ resource.gender | gender }}</td>
                <td class="nowrap">
                    {{ resource.pivot.created_at | datetime }}
                </td>
                <td class="nowrap">{{ resource.pivot.checker }}</td>
                <td class="nowrap">
                    <x-quick-delete-button @click="deleteSubscriber(resource)" :disabled="isLoading" />
                </td>
            </tr>
        </x-table>

        <template #footer>
            <x-excel-export-button :href="exportUrl" />
            <x-close-modal-button />
        </template>
    </x-modal>
</template>

<script>
import XCloseModalButton from "../../components/XCloseModalButton.vue";
import XExcelExportButton from "../../components/XExcelExportButton.vue";
import XModal from "../../components/XModal.vue";
import XQuickDeleteButton from "../../components/XQuickDeleteButton.vue";
import XTable from "../../components/XTable.vue";
import { deletePrompt, handleGeneralXhrError } from "../../helpers";

export default {
    components: {
        XModal,
        XTable,
        XCloseModalButton,
        XExcelExportButton,
        XQuickDeleteButton,
    },
    computed: {
        exportUrl() {
            if (!this.session) return null;
            return `/admin/event-form-sessions/${this.session.id}/export`;
        },
        modalTitle() {
            if (!this.session) return null;
            return `Daftar Absen ${this.session.label}`;
        },
    },
    data() {
        return {
            isLoading: false,
            subscribers: [],
        };
    },
    methods: {
        deleteSubscriber(subscriber) {
            deletePrompt({
                name: subscriber.name,
                onConfirm: () => {
                    this.isLoading = true;
                    const request = axios
                        .delete(`/api/event-form-sessions/${this.session.id}/subscribers`, {
                            data: {
                                subscribers: [{ id: subscriber.id }],
                                token: window.authToken,
                            },
                        })
                        .then(() => {
                            this.$notify({
                                type: "success",
                                title: "Berhasil",
                                text: `${subscriber.name} berhasil dihapus dari sesi!`,
                            });
                            this.$emit("subscriber-deleted", subscriber);
                            this.$set(
                                this,
                                "subscribers",
                                this.subscribers.filter((s) => s.id !== subscriber.id)
                            );
                        });
                    handleGeneralXhrError(request).finally(() => {
                        this.isLoading = false;
                    });
                },
            });
        },
    },
    props: {
        id: {
            type: String,
            default: "event-form-session-subscriber-modal",
        },
        session: {
            type: Object,
            default: null,
        },
    },
    watch: {
        session: {
            deep: true,
            immediate: true,
            handler(newValue) {
                if (newValue && newValue.subscribers) {
                    this.subscribers = [...newValue.subscribers];
                } else {
                    this.subscribers = [];
                }
            },
        },
    },
};
</script>
